import { useQuery } from "react-query";
import AxiosT from "../../setup/setup-axios-bearer";

async function fetchGetBuyFactorDetail(id) {
  const res = await AxiosT.get(`/buy-factor-detail?id=${id}`);
  return res.data;
}

// export function useGetBuyFactorDetail() {
//   return useQuery("getBuyFactordetail", fetchGetBuyFactorDetail);
// }

export function useGetBuyFactorDetail(id) {
  return useQuery(["getBuyFactordetail", id], () =>
    fetchGetBuyFactorDetail(id)
  );
}
